import React, { useState, useMemo } from "react";
import { pushCtaOmniEvents } from "../../../../config/omni";
import { CTA_TYPE } from "../../../../utils/omni-utils"
import { LEAD_GEN_FORM } from "../../../../utils/util-constants";
import { submitQuerydetails } from "../../redux/thunks";
import { AssistantForm } from '@gommt-cabs/ui-lib'

const formatDate = (dateString: string) => {
  const [year, month, day] = dateString.split('-');
  return `${day}/${month}/${year}`;
};

const AssistedForm = ({data, showForm, setShowForm}) => {
  const [formState, setFormState] = useState({
    isSubmitted: false,
    hasError: false,
  });

  const initialFormData = useMemo(() => ({
    from: "Delhi",
    to: "Badrinath"
  }), []);

  const onFormSubmit = (data: any) => {
    const reqBody = {
      destination: data?.to?.val?.toUpperCase() || "",
      email: "",
      mobile: data?.mobileNumber?.val || "",
      name: data?.fullName?.val || "",
      passengers: 1,
      source: data?.from?.val?.toUpperCase() || "",
      travel_date:formatDate(data?.pickUpDate?.val) || "",
      page: "review",
      flavour:"cars_dweb"
    }
    try {
      const res = submitQuerydetails(reqBody);
      res
        .then((result) => {
          const isError = result?.error ? true : false;
          if (!isError) {
            setFormState({
              isSubmitted: true,
              hasError: false,
            });
          } else {
            setFormState({
              isSubmitted: true,
              hasError: true,
            });
          }
        })
        .catch(() => {
          console.log('Error submitting assisted modal query');
        });
    } catch (err) {
      console.log('Error submitting assisted modal form');
    }
  };

  const trackEvent = (eventName: string) => {
    pushCtaOmniEvents(eventName, CTA_TYPE.HYPER_LINK, LEAD_GEN_FORM, window.location.href);
  };
  return (
    <AssistantForm
      initialFormData={initialFormData}
      formState={formState}
      setFormState={setFormState}
      onSubmit={onFormSubmit}
      trackEvent={trackEvent}
      autoOpenDelay={data?.assistedFormOpenDelay}
      pageName="Seo_CharDham"
      showAssistedForm={showForm}
      setShowAssistedForm={setShowForm}
      orgId={"GI"}
    />
  );
};

export default AssistedForm;